
<script>
import MenuApi from "@/services/menu-api";
import QrcodeVue from 'qrcode.vue'

export default {
  components: { QrcodeVue },

  props: {
    menuId: Number,
    start: Number,
    end: Number
  },

  data() {
    return {
      qrTables: [],
      errorGetQrTables: null,
    }
  },


  mounted() {
    this.getQrTables();
  },

  methods: {


    downloadQRCode(index, tableNumber) {

      this.$nextTick(() => {
        const qrRef = this.$refs["qrCode" + index];
        const qrComponent = Array.isArray(qrRef) ? qrRef[0] : qrRef;

        if (!qrComponent || !qrComponent.$el) {
          return;
        }

        const originalSvg = qrComponent.$el.querySelector("svg");
        if (!originalSvg) {
          return;
        }

        const serializer = new XMLSerializer();
        const svgString = serializer.serializeToString(originalSvg);
        const parser = new DOMParser();
        const svgDoc = parser.parseFromString(svgString, "image/svg+xml");
        const originalSvgEl = svgDoc.documentElement;

        const width = parseInt(originalSvgEl.getAttribute("width") || 200);
        const height = parseInt(originalSvgEl.getAttribute("height") || 200) + 40;

        const newSvg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        newSvg.setAttribute("xmlns", "http://www.w3.org/2000/svg");
        newSvg.setAttribute("width", width);
        newSvg.setAttribute("height", height);

        const clonedQr = originalSvgEl.cloneNode(true);
        newSvg.appendChild(clonedQr);

        if(tableNumber > 0){
          const textEl = document.createElementNS("http://www.w3.org/2000/svg", "text");
          textEl.setAttribute("x", "50%");
          textEl.setAttribute("y", height - 15);
          textEl.setAttribute("text-anchor", "middle");
          textEl.setAttribute("font-family", "Arial");
          textEl.setAttribute("font-size", "20");
          textEl.setAttribute("font-weight", "bold");
          textEl.setAttribute("fill", "black");
          textEl.textContent = `TABLE ${tableNumber || index}`;

          newSvg.appendChild(textEl);

        }

        const finalSvgString = serializer.serializeToString(newSvg);
        const blob = new Blob([finalSvgString], { type: "image/svg+xml" });
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = `qrcode-table-${tableNumber || index}.svg`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(url);
      });
    },

    getQrTables() {
      this.errorGetQrTables = null;
      if (this.menuId && this.start != null && this.end != null) {
        MenuApi.getQrTables(this.menuId, this.start, this.end).then((res) => {
          this.qrTables = res;
        }) .catch(error => {this.errorGetQrTables = error });
      }
    },

    generateQrTables(){
      if(this.errorGetQrTables){
        return;
      }

      if (this.menuId && this.start != null && this.end != null) {
        MenuApi.generateQrTables( this.menuId, this.start, this.end)
      }
    },
  }
};
</script>

<template>

  <div class="p-4">
    <div class="d-flex justify-content-end mb-3 d-print-none">
      <a href="javascript:window.print()" class="">
        <b-button
          variant="light"
          size="lg"
          class="mr-2"
        >
          <i class="fa fa-print font-size-16 align-middle mr-2"></i> Imprimer
        </b-button>
      </a>
      <b-button
        variant="info"
        size="lg"
        @click="generateQrTables"
      >
        <i class="fa fa-download font-size-16 align-middle mr-2"></i> Télécharger
      </b-button>
    </div>

    <div
      v-if="errorGetQrTables"
      class="d-flex justify-content-center align-items-center text-center p-4"
      style="min-height: 20em; margin-bottom: 1.5rem;"
    >
      <div
        class="p-3 rounded-sm "
        style="background-color: #ffe6e6; color: #a80000; font-size: 1.2rem; font-weight: 400; letter-spacing: 1px; "
      >
        {{ errorGetQrTables }}
      </div>
    </div>


     <div v-else class="d-flex flex-wrap">
        <div
          v-for="(value, index) in qrTables"
          :key="index"
          class="p-5"
        >
          <qrcode-vue
            :ref="'qrCode' + index"
            :value="value.qrTableUrl"
            :size="200"
            level="H"
            render-as="svg"
          />
          <div v-if="value.tableNumber > 0" class="text-center text-dark mt-1 mb-4">
            <div style="font-size: 20px; font-weight: bold;">TABLE {{ value.tableNumber }}</div>
          </div>
          <b-button
            variant="outline-secondary"
            class="d-print-none"
            @click="downloadQRCode(index, value.tableNumber)"
            style="width: 100%;"
          >
            {{ $t("campaign.text.downloadQRCode") }}
          </b-button>
        </div>
      </div>


  </div>
 
</template>
